exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".footer{background:#002147;color:#fff;font-size:9pt;padding:20px 0;text-align:center}.footer .copyright{color:#fff;line-height:25px}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./src/app/modules/footer/components/style.css
 ** module id = 1473
 ** module chunks = 0
 **/